
import { createRouter, createWebHashHistory } from 'vue-router';

import { useAuth } from 'src/composables/auth';


function passRouteToProps(route) {
	return {
		queryParams: route.query,
		fieldName: route.params.fieldName,
		fieldValue: route.params.fieldValue
	}
}


let routes = [

	//meters routes
	{
		path: '/meters/:fieldName?/:fieldValue?',
		name: 'meterslist',
		component: () => import('./pages/meters/list.vue'),
		props: route => passRouteToProps(route)
	},
	// {
	// 	path: '/meters/view/:id',
	// 	name: 'metersview',
	// 	component: () => import('./pages/meters/view.vue'),
	// 	props: true
	// },
	//vendors routes
	{
		path: '/vendors/view/:id',
		name: 'vendorsview',
		component: () => import('./pages/vendors/view.vue'),
		props: true
	},
	{
		path: '/meters/add',
		name: 'metersadd',
		component: () => import('./pages/meters/add.vue'),
		props: true
	},
	{
		path: '/account',
		name: 'usersaccountview',
		component: () => import('./pages/account/accountview.vue'),
		props: true
	},
	{
		path: '/index/accountblocked',
		name: 'accountblocked',
		component: () => import('./pages/index/accountblocked.vue'),
		props: true
	},
	{
		path: '/index/accountpending',
		name: 'accountpending',
		component: () => import('./pages/index/accountpending.vue'),
		props: true
	},
	{
		path: '/index/forgotpassword',
		name: 'forgotpassword',
		component: () => import('./pages/index/forgotpassword.vue'),
		props: true
	},
	{
		path: '/index/verifyotp',
		name: 'verifyotp',
		component: () => import('./pages/index/verifyotp.vue'),
		props: true
	},
	{
		path: '/error/forbidden',
		name: 'forbidden',
		component: () => import('./pages/errors/forbidden.vue'),
		props: true
	},
	{
		path: '/error/notfound',
		name: 'notfound',
		component: () => import('./pages/errors/pagenotfound.vue'),
		props: true
	},
	{
		path: '/:catchAll(.*)',
		component: () => import('./pages/errors/pagenotfound.vue')
	}
];

export default () => {

	const auth = useAuth();


	const user = auth.user;
	if (user) {
		routes.push({ path: '/', alias: '/home', name: 'home', component: () => import(`./pages/home/home.vue`) });
	}
	else {
		routes.push({ path: '/', alias: '/index', name: 'index', component: () => import('./pages/index/index.vue') });
	}

	const router = createRouter({
		history: createWebHashHistory(),
		routes,
		scrollBehavior(to, from, savedPostion) {
			if (savedPostion) return savedPostion;
			return { top: 0 }
		}
	});

	router.beforeEach((to, from, next) => {
		const user = auth.user;
		let path = to.path;
		let authRequired = auth.pageRequiredAuth(path);

		//authenticate user
		if (authRequired && !user) {
			//user is not logged. redirect to login
			return next({ path: '/', query: { nexturl: to.fullPath } });
		}

		if (user && to.name == "index") {
			//already logged in, show home when try to access index page
			return next({ path: "/home" });
		}

		//navigate to redirect url if available
		if (to.name == "home" && to.query.nexturl) {
			return next({ path: to.query.nexturl });
		}

		//close dialog from previous page
		//store.dispatch('app/closeDialogs');

		//continue to specified route
		next();
	});

	return router;
}
